import { useCallback } from 'react';
import { shallow } from 'zustand/shallow';

import { logsStore } from '../../store/insights/LogsStore';

import { useLogsAttach } from '../../store/insights/useLogs.ts';

export function useLogGroupData({ logs }) {
  useLogsAttach();

  const selector = useCallback(
    (state) => {
      const result = {
        byId: {},
        defaultLog: null,
      };

      if (state.loading === true || state.byId == null) {
        return result;
      }

      for (const [index, logKey] of (logs ?? []).entries()) {
        if (index === 0) {
          result.defaultLog = state.byId[logKey];
        }

        result.byId[logKey] = state.byId[logKey];
      }

      return result;
    },
    [logs]
  );

  return logsStore.store(selector, (prev, next) => {
    return shallow(prev.byId, next.byId) && shallow(prev.defaultLog, next.defaultLog);
  });
}
